import { useCallback, useEffect, useRef } from 'react';

// Debounced callback with a stable identity across renders. Unlike
// utils/common debounce() called in a hook body, the pending timer
// survives re-renders and the callback always sees fresh state.
export default function useDebouncedCallback(callback, delay = 500) {
    const callbackRef = useRef(callback);
    const timerRef = useRef(null);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        return () => clearTimeout(timerRef.current);
    }, []);

    return useCallback((...args) => {
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            callbackRef.current(...args);
        }, delay);
    }, [delay]);
}
